import React from 'react';
import {
  GlobalSearchProvider,
  GlobalSearchResultsPage,
  HeaderSearch as FeatureHeaderSearch,
} from '@hopdrive/feature-global-search';
import { adminSearchConfig } from './searchConfig';

/**
 * Admin's global search mount points.
 *
 * Both are the feature's components wrapped in admin's config (#1237) — the
 * entities, queries, ranking and results page all live in
 * `features/global-search`. Admin's own contribution is ./searchConfig.tsx.
 */

/** Full results for /search?q=… */
export const GlobalSearchPage: React.FC = () => (
  <GlobalSearchProvider config={adminSearchConfig}>
    <GlobalSearchResultsPage />
  </GlobalSearchProvider>
);

/** The header's submit-only search bar. */
export const HeaderSearch: React.FC = () => (
  <GlobalSearchProvider config={adminSearchConfig}>
    <FeatureHeaderSearch />
  </GlobalSearchProvider>
);

export { adminSearchConfig } from './searchConfig';
